<template>
  <iframe
    v-if="notifierUrl"
    ref="iframeRef"
    :src="notifierUrl"
    style="display: none; width: 0; height: 0; border: none"
    title="Notifier Worker"
    @load="sendCredentials"
  />
</template>

<script setup lang="ts">
import {computed, onMounted, onUnmounted, ref, watch} from 'vue';

import settings from '@/config/settings';

import {keycloakAPI} from '@/assets/keycloak';

import {notificationState} from '@/services/state/notification';

const iframeRef = ref<HTMLIFrameElement | null>(null);

const notifierUrl = computed(() => {
  const url = settings.SERVICES.NOTIFIER.URL + '/notification-api-sub';
  return url || null;
});

const notifierOrigin = computed(() => settings.SERVICES.NOTIFIER.URL);

const sendCredentials = () => {
  if (!iframeRef.value?.contentWindow) return;

  const targetOrigin = notifierOrigin.value;

  if (keycloakAPI.getToken.value) {
    iframeRef.value.contentWindow.postMessage(
      {type: 'UPDATE_TOKEN', token: keycloakAPI.getToken.value},
      targetOrigin,
    );
  }

  const plainUserInfo = JSON.parse(
    JSON.stringify(keycloakAPI.getUserInfo.value),
  );
  iframeRef.value.contentWindow.postMessage(
    {type: 'UPDATE_USER_INFO', userInfo: plainUserInfo},
    targetOrigin,
  );

  iframeRef.value.contentWindow.postMessage(
    {type: 'AUTH_CHANGE', isAuthenticated: keycloakAPI.getIsLoggedIn.value},
    targetOrigin,
  );
};

watch([keycloakAPI.getToken, keycloakAPI.getIsLoggedIn], () => {
  sendCredentials();
});

onMounted(() => {
  if (notifierUrl.value) {
    window.addEventListener('message', notificationState.handleMessage);
  }
});

onUnmounted(() => {
  window.removeEventListener('message', notificationState.handleMessage);
});
</script>

<style lang="scss" />
